<script setup lang="ts">
import type { StickerColor } from '@/modules/common/types/sticker-color.type.ts';

export interface UiStickerProps {
  size?: 's' | 'm';
  color?: StickerColor;
}

const { size = 'm', color = 'gray' } = defineProps<UiStickerProps>();
</script>

<template>
  <span
    class="ui-sticker"
    :class="[`_size-${size}`, `_color-${color}`]"
  >
    <slot />
  </span>
</template>

<style scoped lang="scss">
.ui-sticker {
  display: inline-block;

  &._size-s {
    padding: 2px 6px;

    border-radius: 4px;

    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  &._size-m {
    padding: 4px 8px;

    border-radius: 8px;

    font-size: var(--font-size);
    line-height: var(--line-height);
  }

  &._color-light-gray {
    background-color: var(--color-gray-100);
  }

  &._color-gray {
    background-color: var(--color-gray-300);
  }

  &._color-dark-gray {
    color: var(--color-white);
    background-color: var(--color-gray-600);
  }

  &._color-green {
    color: var(--color-white);
    background-color: var(--color-green-800);
  }

  &._color-light-blue {
    color: var(--color-white);
    background-color: var(--color-blue-400);
  }

  &._color-blue {
    color: var(--color-white);
    background-color: var(--color-blue-700);
  }

  &._color-red {
    color: var(--color-white);
    background-color: var(--color-red-900);
  }

  &._color-translucent {
    background-color: rgba(0, 0, 0, 0.1);
    color: rgba(0, 0, 0, 0.3);
  }
}
</style>
